import Portfolio from './Portfolio';
export default Portfolio;